import * as moment from 'moment';

/* The methods included in this file are used for formatting and for the conversion between various date formats */

 /** Method to convert date from the date picker event from dd-mm-yyyy to yyyy-mm-dd format  */
export function formatDate(datePickerEvent) {
    const dateString = (datePickerEvent.date.day).toString().length === 1 ?
                        (0 + (datePickerEvent.date.day).toString()) : (datePickerEvent.date.day).toString();
    const monthString = (datePickerEvent.date.month).toString().length === 1 ?
                                            (0 + (datePickerEvent.date.month).toString()) : (datePickerEvent.date.month).toString();
    const yearString = datePickerEvent.date.year;
    const formattedDate = yearString + '-' + monthString + '-' + dateString;
    return formattedDate;
}

/** Method to convert the next date string of given date string of the format yyyy-mm-dd */
export function getNextDate(dateString) {
    const dateObj = new Date(dateString);
    dateObj.setDate(dateObj.getDate() + 1);
    const month = JSON.stringify(dateObj.getMonth() + 1).length === 1 ?
                    (0 + JSON.stringify(dateObj.getMonth() + 1)) : (JSON.stringify(dateObj.getMonth() + 1));
    const dateStr = JSON.stringify(dateObj.getDate()).length === 1 ?
                            (0 + JSON.stringify(dateObj.getDate())) : (JSON.stringify(dateObj.getDate()));
    const nextDate = dateObj.getFullYear() + '-' + month + '-' + dateStr;
    return (nextDate);
}

/** Method to convert the previous date string of given date string of the format yyyy-mm-dd */
export function getPreviousDate(dateString) {
    const dateObj = new Date(dateString);
    dateObj.setDate(dateObj.getDate() - 1);
    const month = JSON.stringify(dateObj.getMonth() + 1).length === 1 ?
                    (0 + JSON.stringify(dateObj.getMonth() + 1)) : (JSON.stringify(dateObj.getMonth() + 1));
    const dateStr = JSON.stringify(dateObj.getDate()).length === 1 ?
                                            (0 + JSON.stringify(dateObj.getDate())) : (JSON.stringify(dateObj.getDate()));
    const previousDate = dateObj.getFullYear() + '-' + month + '-' + dateStr;
    return (previousDate);
}

/* Method to convert date(in ISO string format) to a single string without seperators */
export function getSingleDateString(date) {
    const newDate = new Date(date);
    const monthString = JSON.stringify(newDate.getMonth() + 1).length === 1 ?
                            (0 + JSON.stringify(newDate.getMonth() + 1)) : (JSON.stringify(newDate.getMonth() + 1));
    const dateString = JSON.stringify(newDate.getDate()).length === 1 ?
                            (0 + JSON.stringify(newDate.getDate())) : (JSON.stringify(newDate.getDate()));
    const formattedDate = newDate.getFullYear() + monthString + dateString;
    return formattedDate;
}

/*Method to convert date (in the format of dd-MM-yyyy) from single date string */
export function getFormattedDateFromSingleString(singleStringDate) {
    const date = singleStringDate.substring(6,8);
    const month = singleStringDate.substring(4,6);
    const year = singleStringDate.substring(0,4);
    return (date + "-" + month + "-" + year);
}

export function formatDateGeneral(date){
    return moment(date).format('YYYY-MM-DD');
 }

 export function returnFormat(date,format){
    moment.locale('nl');
    return moment(date).format(format);
 }
 

